import React, { useEffect, useState } from 'react';
import { DialogTitle, DialogContent, Dialog } from '@ublend-npm/aulaui-next';
import PropTypes from 'prop-types';
import { setAPIBlock } from '../../../utils/api';
import StyledDialogActions from './ActiveDailogBox.styled';
import FlatButton from '../Buttons/FlatButton';

const ActiveDialogBox = ({
  open,
  handleRegenerateSessionToken,
  handleSessionLogout,
}) => {
  const [loading, setLoading] = useState({ primary: false, secoundry: false });

  useEffect(() => {
    if (open) {
      setAPIBlock(true);
    } else {
      setAPIBlock(false);
    }
  }, [open]);

  const handleYesClick = async () => {
    setLoading({
      ...loading,
      primary: true,
    });
    setAPIBlock(false);
    await handleRegenerateSessionToken();
    setLoading({
      ...loading,
      primary: false,
    });
  };

  const handleNoClick = async () => {
    setLoading({
      ...loading,
      secoundry: true,
    });
    setAPIBlock(false);
    await handleSessionLogout();
    setLoading({
      ...loading,
      secoundry: false,
    });
  };

  const displayContent =
    "Please click 'Yes' to stay signed in. If you select 'No,' you will be logged out.";

  const displayTitle = 'Are you still using Aula?';
  return (
    <Dialog open={open} width="600" height="auto">
      <DialogTitle closeIcon={false}>{displayTitle}</DialogTitle>
      <DialogContent>{displayContent}</DialogContent>
      <StyledDialogActions>
        <FlatButton
          label="No"
          onClick={handleNoClick}
          color="outline"
          loading={loading.secoundry}
          disabled={loading.primary}
        >
          No
        </FlatButton>
        <FlatButton
          label="Yes"
          onClick={handleYesClick}
          color="darkBlue"
          loading={loading.primary}
          disabled={loading.secoundry}
        >
          Yes
        </FlatButton>
      </StyledDialogActions>
    </Dialog>
  );
};

ActiveDialogBox.propTypes = {
  open: PropTypes.bool.isRequired,
  handleRegenerateSessionToken: PropTypes.func.isRequired,
  handleSessionLogout: PropTypes.func.isRequired,
};

export default ActiveDialogBox;
